ui-cms-quickfact-group {
  display: block;
  container-type: inline-size;

  .quickfact-group {
    display: grid;
    grid-auto-flow: dense;
    gap: $sd-spacing-8;
    width: 100%;
    position: relative;
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .quickfact-group sd-quickfact::part(content) {
    position: absolute;
    width: 100%;
    left: 0;
  }

  @container (min-width: 600px) {
    .quickfact-group {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @container (min-width: 900px) {
    .quickfact-group {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
}
